import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDialogOptions, PromptDialogService } from '@lc/core';
import { BaseDialog } from '../../../dialogs/base/base.dialog';
import { QRStatisticsTableComponent } from '../qr-statistics-table.component';

export interface IQRDialogData {
  marketingOrderId: string;
}

@Component({
  selector: 'lc-qr-statistics-table-dialog',
  templateUrl: './qr-statistics-table-dialog.component.html',
  styleUrls: ['./qr-statistics-table-dialog.component.scss'],
  imports: [BaseDialog, QRStatisticsTableComponent],
})
export class QRStatisticsTableDialogComponent {
  private dialogRef = inject<MatDialogRef<QRStatisticsTableDialogComponent>>(MatDialogRef);

  readonly marketingOrderId: string;

  constructor() {
    const data = inject<IQRDialogData>(MAT_DIALOG_DATA);

    this.marketingOrderId = data?.marketingOrderId;
  }

  onClose() {
    this.dialogRef?.close();
  }

  /**
   * Opens the form as a dialog
   */
  static async open(service: PromptDialogService, data?: IQRDialogData, options?: IDialogOptions): Promise<void> {
    const defaultOptions: IDialogOptions = { width: '800px' };
    const opts: IDialogOptions = Object.assign(defaultOptions, options);
    return await service.openComponent(QRStatisticsTableDialogComponent, data, opts);
  }
}
